// Minimal async-data hook for V2.
//
// Classic pages each hand-roll loading/error/abort. One hook instead, so
// every V2 screen reports failure the same way — and reports it at all: a
// data-intensive console that silently renders an empty table on a 500 is
// worse than one that says it failed.

import { useCallback, useEffect, useRef, useState } from 'react';

export default function useApi(fn, deps = [], { auto = true } = {}) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(auto);
  const seq = useRef(0);

  const run = useCallback(async () => {
    const mine = ++seq.current;
    setLoading(true);
    setError(null);
    try {
      const res = await fn();
      if (mine === seq.current) setData(res);
    } catch (e) {
      // Surface the server's own message when it sent one — "Failed to fetch
      // from billing service" tells the operator far more than "Error".
      if (mine === seq.current) {
        setError(e?.response?.data?.error || e?.response?.data?.details || e?.message || 'Request failed');
      }
    } finally {
      if (mine === seq.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => { if (auto) run(); }, [run, auto]);

  return { data, error, loading, reload: run };
}
